import { config } from '../shared'

export const logout = () => location.replace(config.ssoBaseUrl.concat('/logout'))

export const showAccessDeniedPage = (deniedPath: string = location.pathname) =>
  location.replace(`/access-denied?path=${encodeURIComponent(deniedPath)}`)
